import PhoneInput from "react-phone-input-2";
import { styled } from "@mui/system";
import "react-phone-input-2/lib/material.css";

const StyledPhoneInputWrapper = styled("div")(({ theme }) => ({
  margin: "10px 0",
  "& .form-control": {
    width: "100%",
    height: "48px", // Slightly smaller height to match form's compact style
    fontSize: "0.9rem", // Match the form's smaller text size
    paddingLeft: "48px", // Leave room for flag
    borderRadius: "4px",
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.mode === "dark" ? "#3d3d43" : theme.palette.background.paper, // Light mode: white background
    color: theme.palette.text.primary, // Dynamic text color (black in light mode, light gray in dark)
    "&:focus": {
      borderColor: theme.palette.primary.main, // Blue focus ring in both modes
      boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
      outline: "none",
    },
    "&:hover": {
      borderColor: theme.palette.text.secondary, // Subtle hover effect
    },
  },
  "& .special-label": {
    color: theme.palette.text.secondary, // Softer label color (gray in both modes)
    backgroundColor: theme.palette.mode === "dark" ? "#3d3d43" : theme.palette.background.paper, // Match input background
    fontSize: "0.9rem", // Smaller label text
  },
  "& .country-list": {
    backgroundColor: theme.palette.mode === "dark" ? "#3d3d43" : theme.palette.background.paper, // Match background
    color: theme.palette.text.primary, // Match text color
    border: `1px solid ${theme.palette.divider}`,
    fontSize: "0.9rem", // Smaller dropdown text
    "& .country": {
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
      "&.highlight": {
        backgroundColor: theme.palette.action.selected,
      },
    },
  },
  "& .flag": {
    filter: theme.palette.mode === "dark" ? "brightness(0.8)" : "none", // Dim flags only in dark mode
  },
}));

function PhoneField({ phone, setPhone }) {
  // Handle the change of the phone number
  const handlePhoneChange = (value) => {
    setPhone(value); // Update the phone number state
  };

  return (
    <StyledPhoneInputWrapper>
      <PhoneInput
        country={"cy"}
        value={phone}
        onChange={handlePhoneChange}
        inputProps={{
          required: true,
          name: "phone",
        }}
      />
    </StyledPhoneInputWrapper>
  );
}

export default PhoneField;